/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './putActivitySubscription.defs'
export { main as default } from './putActivitySubscription.defs'
